import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/w/contracts/$snapshotId')({
  staticData: { breadcrumb: 'Contract Detail', breadcrumbKey: 'K_BREADCRUMB_CONTRACT_DETAIL' },
});
